export const loadExternalScript = (url: string, callback: () => void) => {
  const script = document.createElement("script");
  script.src = url;
  script.id = "gScript";
  document.body.appendChild(script);
  script.onload = () => {
    callback();
  };
};

export const preSignedToBase64 = async (base64Url: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    fetch(base64Url)
      .then((val) => val.blob())
      .then((data) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          resolve(reader.result as string);
        };
        reader.readAsText(data);
      })
      .catch((error) => reject(error));
  });
};
